(function () {
  /**
   * @ngdoc module
   * @name binky.core.organizations.user-list
   * @description module that defines the OrganizationUserList2 model
   */
  angular.module('binky.core.organizations.user-list', [
    'binky.core.api.jil',
    'binky.core.common.list',
    'binky.core.common.member',
    'binky.core.lodash',
  ]);
})();
